import React, { Fragment } from 'react';
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";

const TermsAndConditions = () => {
    return (
        <Fragment>
            <Header />
            <PageHeader title={'Terms & Conditions'} curPage={'Terms & Conditions'} />
            <div className="terms-section padding-tb section-bg">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-12">
                            <div className="terms-content" style={{ background: "#fff", padding: "40px", borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.06)" }}>
                                <div className="text-center mb-4">
                                    <h2 style={{ color: "#102a43", fontWeight: "700", marginBottom: "10px" }}>Terms &amp; Conditions</h2>
                                    <h4 style={{ color: "#f58220", fontWeight: "600" }}>Hidaya International Schools App</h4>
                                    <p className="text-muted" style={{ fontSize: "14px", fontStyle: "italic", marginTop: "5px" }}>
                                        Last Updated: August 21, 2026
                                    </p>
                                </div>
                                <hr style={{ margin: "25px 0 35px", borderColor: "#eee" }} />

                                <div className="policy-section mb-4">
                                    <p style={{ lineHeight: "1.8", color: "#486581", fontSize: "15px" }}>
                                        Welcome to the <strong>Hidaya International Schools App</strong>. By downloading, installing, or using this application, you agree to comply with and be bound by the following terms and conditions.
                                    </p>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3 style={{ color: "#102a43", fontSize: "20px", fontWeight: "600", marginBottom: "12px" }}>
                                        1. Acceptance of Terms
                                    </h3>
                                    <p style={{ lineHeight: "1.8", color: "#486581" }}>
                                        By using this app, you represent that you are either a parent/guardian of a student, a registered student, a faculty member, or an authorized administrator of Hidaya International Schools. If you do not agree to these terms, please do not use the application.
                                    </p>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3 style={{ color: "#102a43", fontSize: "20px", fontWeight: "600", marginBottom: "12px" }}>
                                        2. User Roles &amp; Account Security
                                    </h3>
                                    <ul style={{ paddingLeft: "20px", lineHeight: "1.8", color: "#486581" }}>
                                        <li className="mb-2">
                                            <strong>Parents / Students:</strong> Responsible for maintaining the confidentiality of login credentials provided by the campus.
                                        </li>
                                        <li className="mb-2">
                                            <strong>Teachers / Staff:</strong> Must use the app strictly for educational and administrative purposes.
                                        </li>
                                        <li className="mb-2">
                                            <strong>Campuses:</strong> Responsible for the accuracy of the data uploaded (attendance, marks, fee vouchers).
                                        </li>
                                    </ul>
                                    <p style={{ lineHeight: "1.8", color: "#486581", marginTop: "10px" }}>
                                        Users are responsible for all activities occurring under their account.
                                    </p>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3 style={{ color: "#102a43", fontSize: "20px", fontWeight: "600", marginBottom: "12px" }}>
                                        3. Transparency &amp; Data Usage
                                    </h3>
                                    <ul style={{ paddingLeft: "20px", lineHeight: "1.8", color: "#486581" }}>
                                        <li className="mb-2">
                                            <strong>01. Purpose:</strong> Data collected (attendance, grades, and financial records) is used solely to enhance the educational experience and streamline administrative tasks.
                                        </li>
                                        <li className="mb-2">
                                            <strong>02. Visibility:</strong> Parents have the right to view all academic and financial records pertaining to their children.
                                        </li>
                                        <li className="mb-2">
                                            <strong>03. Third-Party Sharing:</strong> We do not sell user data to third-party advertisers. Data is only shared with authorized service providers (e.g., payment gateways) to facilitate school-related transactions.
                                        </li>
                                        <li className="mb-2">
                                            <strong>04. Audit Logs:</strong> For security and transparency, administrative actions (such as grade changes or fee adjustments) are logged and monitored.
                                        </li>
                                    </ul>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3 style={{ color: "#102a43", fontSize: "20px", fontWeight: "600", marginBottom: "12px" }}>
                                        4. Financial Transactions &amp; Fees
                                    </h3>
                                    <p style={{ lineHeight: "1.8", color: "#486581" }}>
                                        The app allows for the viewing and generation of digital fee vouchers. Online payments are processed via third-party secure gateways. Hidaya International Schools is not responsible for bank-side delays or technical failures during the transaction process. Refunds for school fees are governed by the specific campus's refund policy, not the app's digital interface.
                                    </p>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3 style={{ color: "#102a43", fontSize: "20px", fontWeight: "600", marginBottom: "12px" }}>
                                        5. Prohibited Conduct
                                    </h3>
                                    <p style={{ lineHeight: "1.8", color: "#486581" }}>
                                        Users agree not to:
                                    </p>
                                    <ul style={{ paddingLeft: "20px", lineHeight: "1.8", color: "#486581" }}>
                                        <li className="mb-2">Attempt to bypass security features or access data not belonging to them.</li>
                                        <li className="mb-2">Post or transmit any defamatory, offensive, or unauthorized content.</li>
                                        <li className="mb-2">Use the app for any commercial solicitation or unauthorized advertising.</li>
                                    </ul>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3 style={{ color: "#102a43", fontSize: "20px", fontWeight: "600", marginBottom: "12px" }}>
                                        6. Limitation of Liability
                                    </h3>
                                    <ul style={{ paddingLeft: "20px", lineHeight: "1.8", color: "#486581" }}>
                                        <li className="mb-2">
                                            <strong>Uptime:</strong> While we strive for 100% uptime, we are not liable for temporary outages due to maintenance or connectivity issues.
                                        </li>
                                        <li className="mb-2">
                                            <strong>Accuracy:</strong> Inaccuracies in data entry by campus staff should be reported to the respective campus office.
                                        </li>
                                    </ul>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3 style={{ color: "#102a43", fontSize: "20px", fontWeight: "600", marginBottom: "12px" }}>
                                        7. Modifications
                                    </h3>
                                    <p style={{ lineHeight: "1.8", color: "#486581" }}>
                                        Hidaya International Schools reserves the right to update features, change the user interface, or modify these terms at any time. Significant changes will be communicated via in-app notifications.
                                    </p>
                                </div>

                                <div className="policy-section mb-2" style={{ background: "#f8f9fa", padding: "25px", borderRadius: "8px", borderLeft: "4px solid #f58220" }}>
                                    <h3 style={{ color: "#102a43", fontSize: "20px", fontWeight: "600", marginBottom: "12px" }}>
                                        8. Contact Information
                                    </h3>
                                    <p style={{ lineHeight: "1.8", color: "#486581", marginBottom: "10px" }}>
                                        For questions regarding these Terms or the Transparency policy, please contact:
                                    </p>
                                    <div style={{ color: "#334e68", lineHeight: "1.8" }}>
                                        <strong>Hidaya International Schools Support Team</strong><br />
                                        📍 103 N Block Model Town Lahore, Pakistan<br />
                                        ✉️ Email: <a href="mailto:info@hint.edu.pk" style={{ color: "#f58220" }}>info@hint.edu.pk</a><br />
                                        🌐 Website: <a href="https://www.hint.edu.pk" target="_blank" rel="noreferrer" style={{ color: "#f58220" }}>www.hint.edu.pk</a><br />
                                        📞 Phone: +9233-HIDAYA-22
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </Fragment>
    );
};

export default TermsAndConditions;
